import { userActions } from "../../actionTypes";

const initialState = {
	status: false,
	loading: false,
	error: null,
};

const Reducer = (state = initialState, action) => {
	switch (action.type) {
		case userActions.VERIFY_EMAIL: {
			return { ...state, loading: true };
		}

		case userActions.VERIFICATION_FULLFILLED: {
			return { ...state, loading: false, status: true };
		}

		case userActions.VERIFICATION_REJECTED: {
			return { ...state, loading: false, error: action.payload };
		}

		default:
	}

	return state;
};

export default Reducer;
